var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('wep-loading',{attrs:{"is-loading":_vm.isLoading}}),_vm._v(" "),_c('iframe',{staticStyle:{"width":"0px","height":"0px","border":"none","visibility":"hidden","display":"none"},attrs:{"id":"panoptoIframe"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726e925c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/contents/main/PanoptoPlayer.vue
// module id = xusr
// module chunks = 1